import dynaForms from '@elab/core/utils/dynaForms';
import { initialState as dynaInitialState } from '@elab/core/utils/dynaForms/reducers';

import getTypes from './types';

export const initialState = state => ({
    ...dynaInitialState(state),
    isCheckoutFlow: false,
    useAsPopup: false,
});

const createReducer = storeName => {
    const dynaFormReduce = dynaForms.createReducer(storeName);
    const types = getTypes(storeName);
    return (state = initialState(), action) => {
        state = dynaFormReduce(state, action);
        switch (action.type) {
            case types.GUEST_USER_ATTEMPTED_PROFILE:
                return {
                    ...state,
                    profile: action.payload,
                };
            case types.IS_CHECKOUT_FLOW:
                return {
                    ...state,
                    isCheckoutFlow: action.payload.checkoutFlow,
                    dataPayload: action.payload.dataPayload,
                };
            case types.TOGGLE_SHOW_SUCCESS_MSG:
                return {
                    ...state,
                    showSuccessMsg: !state.showSuccessMsg,
                };
            case types.USE_AS_POPUP:
                return {
                    ...state,
                    useAsPopup: action.payload,
                };
            case types.UPDATE_PHONE_POPUP_ENABLED:
                return {
                    ...state,
                    updatePhonePopupEnabled: true,
                };
            default:
                return state;
        }
    };
};

export default createReducer;
